"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function (m, exports) {
    for (var p in m)
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
            __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttachGlobalProductTreeToCatalog = exports.useProductTree = void 0;
var get_product_tree_hook_1 = require("./hooks/get-product-tree.hook");
Object.defineProperty(exports, "useProductTree", { enumerable: true, get: function () { return get_product_tree_hook_1.useProductTree; } });
var attach_global_product_tree_to_catalog_hook_1 = require("./attach-global-product-tree-to-catalog.hook");
Object.defineProperty(exports, "useAttachGlobalProductTreeToCatalog", { enumerable: true, get: function () { return attach_global_product_tree_to_catalog_hook_1.useAttachGlobalProductTreeToCatalog; } });
__exportStar(require("./hooks"), exports);
__exportStar(require("./gql"), exports);
